//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SettingsFraud from './SettingsFraud/SettingsFraud.vue';
import SettingsIndividual from './SettingsIndividual/SettingsIndividual.vue';
import SettingsLimits from './SettingsLimits/SettingsLimits.vue';

export default {
  components: {
    SettingsIndividual,
    SettingsLimits,
    SettingsFraud,
  },
};
